import type {PageUser} from './pages';
import type {Group} from './groups';

export interface Acl {
    acl_type: AccessType;
    break_inheritance: boolean;
    is_readonly: boolean;
    users?: PageUser[];
    groups?: Group[];
    inherits_from?: {
        id: number;
        slug: string;
    };
}

export interface Access {
    type: AccessType;
    is_readonly: boolean;
    has_external: boolean;
    inherits_from?: {
        id: number;
        slug: string;
    };
}

export enum AccessType {
    Default = 'default',
    OnlyAuthors = 'only_authors',
    Custom = 'custom',
}
